export const buildGridGallery = (list) => {
    const imageGalleryArray = list.map((img, index) => ({
        ...img,
        idx: index
    }));

    const fff = [];
    const chunkSize = 4;
    const gridItems = [];

    for (let i = 0; i < imageGalleryArray.length; i += chunkSize) {
        const chunk = imageGalleryArray.slice(i, i + chunkSize);

        fff.push(chunk);
    }

    const orderGrid = opt => {
        let optString = '';

        if (opt === 0) optString = 'tall';
        if (opt === 1) optString = '';
        if (opt === 2) optString = 'wide';
        if (opt === 3) optString = '';

        return optString;
    };

    for (const groupImg of fff) {
        for (let index = 0; index < groupImg.length; index++) {
            gridItems.push(
                {
                    classname: `grid-item ${orderGrid(index)}`,
                    uri: groupImg[index].cloudUri,
                    index: groupImg[index].idx,
                    description : groupImg[index].description
                }
            );
        }
    }

    return gridItems;
}